module.exports = __webpack_public_path__ + "static/media/coworking.1fae3f5b.jpg";